var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"goods-card"},[_c('van-skeleton',{staticClass:"skeleton",attrs:{"avatar":"","avatar-shape":'square',"row":5,"row-width":['50%', '100%', '100%', '50%', '20%']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }